import script from "./TeamMembersModalButton.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamMembersModalButton.vue?vue&type=script&setup=true&lang=js"

import "./TeamMembersModalButton.vue?vue&type=style&index=0&id=2cc7540c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cc7540c"]])

export default __exports__